import { call, put,  takeLatest } from 'redux-saga/effects';
import {
    dEpsAddPosSettingsForTerminalsSagaAC, dEpsBulkDisconnectTerminalsFromEpsSagaAC,
     dEpsDisconnectTerminalItemFromEpsSagaAC,
    dEpsSetDataAC,
    dEpsSetDataSagaAC,
    dEpsSetEpsListAC, dEpsSetPosSettingsListAC,
} from 'model/dashboardEPS/dEpsActionCreators';
import { addNotificationAC, dashboardLoaderAC, logoutSagaAC } from 'model/system/systemActionCreators';
import {

    typeEpsTableDataItem, typeMerchantPaymentSystem,
    typePosSettingsEpsItem,
    typeTerminalItem
} from 'model/dashboardEPS/dEpsReducer';
import {
    addPosSettingsForTerminal,
    getMerchantsEps,
    getTerminalsList,
    getPosSettingsList, disconnectPosItem, typePosSettingsItemPutRequest, disconnectPosItemBulk
} from 'model/dashboardEPS/dEpsAPI';
import { notificationCreator } from 'model/system/utils';

function availableEpsMapper(availableEpsList: typeMerchantPaymentSystem[], epsWithPos: typePosSettingsEpsItem[]) {
    const mapEpsByPosCount: Record<string, string[]> = availableEpsList.reduce((acc, cur) => {
        // @ts-ignore
        acc[cur.paymentSystem.id] = []
        return acc
    }, {})
    epsWithPos.forEach((pos) => {
        pos.paymentSystemObjects.forEach(obj => {
            if (mapEpsByPosCount.hasOwnProperty(obj.paymentSystem.paymentSystem.id)) {
                mapEpsByPosCount[obj.paymentSystem.paymentSystem.id].push(pos.posId)
            }
        })
    })

    return availableEpsList.map(item => ( {
        ...item,
        checked: false,
        terminalsIds: mapEpsByPosCount[item.paymentSystem.id]
    } )).filter(item=> item.active)
}

function dataEpsMapper(terminals: typeTerminalItem[], availableEps: typeMerchantPaymentSystem[], epsWithPos: typePosSettingsEpsItem[]): typeEpsTableDataItem[] {

    const availableEpsObject = availableEps.reduce((acc: { epsId: string, active: boolean }[], cur) => {
       if(cur.active) {
           acc.push({ epsId: cur.paymentSystem.id, active: false })
       }
        return acc
    }, [])

    // map for epsWithPos by posId
    const mapEpsByPosId: Record<string, any> = {}
    for (let i = 0; i < epsWithPos.length; i++) {
        mapEpsByPosId[epsWithPos[i].posId] = epsWithPos[i]
    }
    // map by terminals for adding epsList
    const temp = terminals.map((terminal) => {

        const epsList: typeEpsTableDataItem['epsList'] = availableEpsObject.map((item) => {
            const tempObj = {
                epsId: item.epsId,
                active: mapEpsByPosId[terminal.id] ? mapEpsByPosId[terminal.id].paymentSystemObjects.findIndex((paymentSystemObject: any) => paymentSystemObject.paymentSystem.id === item.epsId) > -1 : false,
                externalId: mapEpsByPosId[terminal.id] ? mapEpsByPosId[terminal.id].paymentSystemObjects.find((paymentSystemObject: any) => paymentSystemObject.paymentSystem.id === item.epsId)?.externalId || null : null,
            }
            return tempObj
        })

        return {
            terminalData: terminal,
            epsList: epsList,
            checked: false,
            posSettings: mapEpsByPosId[terminal.id] || null
        }
    })

    return temp
}


// Get data function-generator
function* getData() {

    const responseMerchantsEps = yield call(getMerchantsEps)
    const responseTerminalsList = yield call(getTerminalsList)
    const responsePosSettingsList = yield call(getPosSettingsList)

    if (responseMerchantsEps.status === 200) {
        yield put(dEpsSetEpsListAC(responseMerchantsEps.data))
    } else {
        yield errorGenerator(responseMerchantsEps)
    }
    if (responseMerchantsEps.status === 200 && responseTerminalsList.status === 200 && responsePosSettingsList.status === 200) {
        yield put(dEpsSetPosSettingsListAC(responsePosSettingsList.data))

        const mapDataForEps = availableEpsMapper(responseMerchantsEps.data, responsePosSettingsList.data)
        yield put(dEpsSetEpsListAC(mapDataForEps))

        const mapData = dataEpsMapper(responseTerminalsList.data, responseMerchantsEps.data, responsePosSettingsList.data)
        yield put(dEpsSetDataAC(mapData))
    } else {
        if (responseTerminalsList.status !== 200) {
            yield errorGenerator(responseTerminalsList)
        }
        if (responsePosSettingsList.status !== 200) {
            yield errorGenerator(responsePosSettingsList)
        }
    }
}

// Error notification generator
function* errorGenerator(response: any, message?: string) {
    if (response.status === 401) {
        yield put(logoutSagaAC())
    } else {
        const id = new Date()
        yield put(addNotificationAC({
                                        id: id.getTime().toString(),
                                        message: message ? message : 'ERROR_SERVER_CONNECTION',
                                    }))
    }
    console.log(response)
}


// ---------------------------------------------------------------------------------------------------------------------
// Set ePS list saga
export function* dEpsSetDataWorker(actionObject: { type: string }): any {

    yield put(dashboardLoaderAC(true))

    yield getData()

    yield put(dashboardLoaderAC(false))

}

export function* dEpsSetDataWatcher() {
    yield takeLatest(dEpsSetDataSagaAC.type, dEpsSetDataWorker)
}

// ---------------------------------------------------------------------------------------------------------------------

// add pos settings  saga ---connect terminal for eps
export function* dEpsAddPosSettingsForTerminalWorker(actionObject: { type: string, payload: { terminalIds: string[], psObjectId: string } }): any {

    yield put(dashboardLoaderAC(true))

    const response = yield call(addPosSettingsForTerminal, actionObject.payload)

    if (response.status === 200) {
        yield getData()
    } else {
        yield errorGenerator(response, 'SUCCESS_CONNECT_ITEM')
    }


    yield put(dashboardLoaderAC(false))

}

export function* dEpsAddPosSettingsForTerminalWatcher() {
    yield takeLatest(dEpsAddPosSettingsForTerminalsSagaAC.type, dEpsAddPosSettingsForTerminalWorker)
}

// ---------------------------------------------------------------------------------------------------------------------

// edit pos settings for terminal - disconnect terminal from eps'
export function* dEpsDisconnectTerminalItemFromEpsWorker(actionObject: { type: string, payload: { terminalId: string, epsIds: string[], terminalPosSettings: typePosSettingsEpsItem } }): any {

    yield put(dashboardLoaderAC(true))

    // prepare data for endpoint

    const newPSObject = actionObject.payload.terminalPosSettings.paymentSystemObjects.filter(item => !actionObject.payload.epsIds.includes(item.paymentSystem.paymentSystem.id))


    const newPosSettings: typePosSettingsItemPutRequest = {
        id: actionObject.payload.terminalPosSettings.id,
        posId: actionObject.payload.terminalPosSettings.posId,
        paymentSystemObjectsIds: newPSObject.map(item => item.id)
    }

    const response = yield call(disconnectPosItem, { posSettings: newPosSettings })

    if (response.status === 200) {
        yield notificationCreator('SUCCESS_DISCONNECT_ITEM')
        yield getData()
    } else {
        yield notificationCreator('ERROR_DISCONNECT_ITEM')
        yield errorGenerator(response)
    }


    yield put(dashboardLoaderAC(false))

}

export function* dEpsDisconnectTerminalItemFromEpsWatcher() {
    yield takeLatest(dEpsDisconnectTerminalItemFromEpsSagaAC.type, dEpsDisconnectTerminalItemFromEpsWorker)
}


// bulk edit pos settings for terminal - disconnect terminals from eps' bulk
export function* dEpsBulkDisconnectTerminalsFromEpsWorker(actionObject: { type: string, payload: { terminalIds: string[], epsIds: string[], posSettings: typePosSettingsEpsItem[] } }): any {

    yield put(dashboardLoaderAC(true))

    // prepare data for endpoint

    //   идем  map по пос сеттингс , для каждой пос сеттингс
    // если posId входит в набор terminalId, заходим в paymentSystemObjects и фильтруем  входит ли он в набор эпс по id,
    //  поле paymentSystemObject меняем на paymentSystemObjectsIds с массивом id paymentSystemObjects,
    //  у которых paymentSystem.paymentSystem.id не входит в набор эпс

    const newPosSettingsArray = actionObject.payload.posSettings.map(posSettings => {
        if (actionObject.payload.terminalIds.includes(posSettings.posId)) {
            const newSettingsObject: typePosSettingsItemPutRequest = {
                id: posSettings.id,
                posId: posSettings.posId,
                paymentSystemObjectsIds: posSettings.paymentSystemObjects.filter(item => !actionObject.payload.epsIds.includes(item.paymentSystem.paymentSystem.id))
                    .map(item => item.id)
            }
            return newSettingsObject

        } else {
            const newSettingsObject: typePosSettingsItemPutRequest = {
                id: posSettings.id,
                posId: posSettings.posId,
                paymentSystemObjectsIds: posSettings.paymentSystemObjects.map(item => item.id)
            }
            return newSettingsObject
        }


    })

    const response = yield call(disconnectPosItemBulk, { posSettings: newPosSettingsArray })

    if (response.status === 200) {
        yield notificationCreator('SUCCESS_DISCONNECT_ITEM')
        yield getData()
    } else {
        yield notificationCreator('ERROR_DISCONNECT_ITEM')
        yield errorGenerator(response)
    }


    yield put(dashboardLoaderAC(false))

}

export function* dEpsBulkDisconnectTerminalsFromEpsWatcher() {
    yield takeLatest(dEpsBulkDisconnectTerminalsFromEpsSagaAC.type, dEpsBulkDisconnectTerminalsFromEpsWorker)
}
